import { fetchHelper } from './fetch';

import type { UnixTimestamp } from '@vgtv/api-client';

export interface ServerTime {
  time: UnixTimestamp;
  receivedAt: UnixTimestamp;
}

const serverTimeState = {
  isFetching: false,
  isFetched: false,
};

async function fetchServerTime(): Promise<ServerTime> {
  serverTimeState.isFetching = true;

  const serverTime = await fetchHelper<UnixTimestamp>(
    'https://time.akamai.com'
  );

  serverTimeState.isFetched = true;
  serverTimeState.isFetching = false;

  return {
    time: serverTime,
    receivedAt: Date.now() / 1000,
  };
}

function getCurrentServerTime(serverTime: ServerTime) {
  const serverTimeDrift = Date.now() / 1000 - serverTime.receivedAt;

  return Math.round(serverTime.time + serverTimeDrift);
}

window.getCurrentServerTime = getCurrentServerTime;

export { fetchServerTime, getCurrentServerTime, serverTimeState };
